const GALLERY = [];

export default GALLERY;
